// extracted by mini-css-extract-plugin
export var editButton = "_p0-0";